/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Login_PromptInputs */



/**
* | output |
* | --- |
* | "Sign in to see the rankings and the Hall of Fame." |
*
* @param {Rankings_Login_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_login_prompt = /** @type {((inputs?: Rankings_Login_PromptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Login_PromptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous pour voir les classements et le Hall of Fame.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicia sesión para ver las clasificaciones y el Hall of Fame.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entre para ver as classificações e o Hall da Fama.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi per vedere le classifiche e la Hall of Fame.")
	return /** @type {LocalizedString} */ ("Sign in to see the rankings and the Hall of Fame.")
});